import { useEffect } from 'react'
import { trackAppTime } from './supabase'
import { HEARTBEAT_MS, secondsToCredit } from './appTime'

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'wheel']

/**
 * Counts time in Agency Base while the tab is on screen and the person is
 * active. One small call a minute; nothing at all while hidden or idle.
 * Staff only: pass enabled=false for creator logins.
 */
export function useAppTimeTracker(enabled) {
  useEffect(() => {
    if (!enabled) return
    let lastBeatAt = Date.now()
    let lastActivityAt = Date.now()
    const markActive = () => { lastActivityAt = Date.now() }

    // `wasVisible` lets the leaving-the-tab flush count the time just before
    // the tab was hidden; by the time that event fires the page already is.
    const beat = (wasVisible = document.visibilityState === 'visible') => {
      const now = Date.now()
      const seconds = secondsToCredit({ now, lastBeatAt, lastActivityAt, visible: wasVisible })
      lastBeatAt = now
      if (seconds > 0) trackAppTime(seconds).catch(() => {})
    }
    // Leaving the tab: credit the partial minute, then stop counting.
    // Coming back: start a fresh interval so hidden time is never credited.
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') beat(true)
      else { lastBeatAt = Date.now(); lastActivityAt = Date.now() }
    }

    ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, markActive, { passive: true }))
    document.addEventListener('visibilitychange', onVisibility)
    const id = setInterval(() => beat(), HEARTBEAT_MS)
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', onVisibility)
      ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, markActive))
    }
  }, [enabled])
}
